module.exports = __webpack_public_path__ + "static/media/grandmaster-icon.298ab89b.png";